import { render } from "./VersionUpdates.vue?vue&type=template&id=491ddd5d&scoped=true"
import script from "./VersionUpdates.vue?vue&type=script&lang=js"
export * from "./VersionUpdates.vue?vue&type=script&lang=js"

import "./VersionUpdates.vue?vue&type=style&index=0&id=491ddd5d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491ddd5d"]])

export default __exports__